/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { Patient } from '../backendModels/patient.model';

export class PatientChangeEvent extends Event {
  change: Patient;

  constructor(type: string, newPatient: Patient) {
    super(type, { bubbles: true });

    this.change = newPatient;
  }
}
